module.exports = __webpack_public_path__ + "static/img/12.56d246f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/eng/12.png
// module id = vuBu
// module chunks = 0